import {
  FacilityType,
  FacilityWidth,
  FlowDirectionType,
  NumberOfLanesType,
  Score,
} from "@keita/lanepatrol-sdk";

export interface HlaLane {
  hlaWayId: string;
  frontFacing: boolean;
  adjacentFeaturesLeft: HlaWayAdjacentFeatures;
  adjacentFeaturesRight: HlaWayAdjacentFeatures;
  flowDirection: FlowDirectionType | null;
  facilityType: FacilityType | null;
  facilityWidthPerDirection: FacilityWidth | null;
  lightSegregation: boolean;
  tramOrTrainRails: boolean;
  score: Score | null;
}

export interface CreateOrUpdateHlaLane {
  frontFacing: boolean;
  adjacentFeaturesLeft: HlaWayAdjacentFeatures;
  adjacentFeaturesRight: HlaWayAdjacentFeatures;
  flowDirection: FlowDirectionType | null;
  facilityType: FacilityType | null;
  facilityWidthPerDirection: FacilityWidth | null;
  lightSegregation: boolean;
  tramOrTrainRails: boolean;
}

export interface HlaWayAdjacentFeatures {
  roadLane: PresenceDistance | null;
  vehicleParking: PresenceDistance | null;
  severeHazard: PresenceDistance | null;
  objectOrLevelChange: PresenceDistance | null;
  sidewalk: PresenceDistance | null;
  numberOfLanes: NumberOfLanesType | null;
  hardSegregation: boolean;
}

export const buildCreateOrUpdateHlaLane = (
  frontFacing = true,
): CreateOrUpdateHlaLane => ({
  frontFacing,
  adjacentFeaturesLeft: {
    roadLane: null,
    sidewalk: null,
    severeHazard: null,
    vehicleParking: null,
    objectOrLevelChange: null,
    numberOfLanes: null,
    hardSegregation: false,
  },
  adjacentFeaturesRight: {
    roadLane: null,
    sidewalk: null,
    severeHazard: null,
    vehicleParking: null,
    objectOrLevelChange: null,
    numberOfLanes: null,
    hardSegregation: false,
  },
  flowDirection: null,
  facilityType: null,
  facilityWidthPerDirection: null,
  lightSegregation: false,
  tramOrTrainRails: false,
});

export enum PresenceDistance {
  From0to1m = "From0to1m",
  From1to3m = "From1to3m",
}

export enum RaInfrastructureType {
  Road = "Road",
  Parking = "Parking",
  Cycle = "Cycle",
  Sidewalk = "Sidewalk",
  Separation = "Separation",
}
